import { render, staticRenderFns } from "./depth.vue?vue&type=template&id=2dc86d53&scoped=true&"
import script from "./depth.vue?vue&type=script&lang=js&"
export * from "./depth.vue?vue&type=script&lang=js&"
import style0 from "./depth.vue?vue&type=style&index=0&id=2dc86d53&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc86d53",
  null
  
)

export default component.exports